 import { store } from "../../../Redux/store/index";
const workerUrl = new URL('./test.worker.js', import.meta.url);

export const CanOrderCalculateTravelCost = (prevData, NextData ,call) => {
  const worker = new Worker(workerUrl );
  
  console.log("CanOrderCalculateTravelCost ",prevData, NextData)
  worker.postMessage({
    prevData, NextData
  });

  worker.addEventListener("message", (event) => {
     if (event.data.succeessfull) {
      call(true)
    } else {
      call(false)
    }

    worker.terminate();
  });
};
